import { Collapse, CollapseProps } from 'antd'
import cn from 'classnames'
import { ReactComponent as ArrowDown16 } from 'assets/svg/ArrowDown16.svg'
import { ReactComponent as ArrowRight16 } from 'assets/svg/ArrowRight16.svg'
import './collapse.attachment.scss'

export const Attachment = ({
  className,
  accordion = true,
  ...props
}: CollapseProps) => (
  <Collapse
    className={cn('collapse-attachment', className)}
    expandIconPosition="right"
    expandIcon={(panelProps) =>
      panelProps.isActive ? <ArrowDown16 /> : <ArrowRight16 />
    }
    accordion={accordion}
    {...props}
  />
)
